import { State as RootState } from '@/store/state'
import { ActionTree } from 'vuex'

import { DetailsModule } from './state'

export const actions: ActionTree<DetailsModule, RootState> = {}
